import { useEffect } from 'react';

// @mui
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import HeaderBreadcrumbs from '../../components/header-breadcrumbs';
import { Widget404, LoadSkeleton } from '../../components/widegts';
import Markdown from '../../components/markdown';
import { Seo } from '../../components/seo';

// redux
import { useDispatch, useSelector } from '../../redux/store';

// data
import { getCms } from '../../redux/slices/cms';

// ----------------------------------------------------------------------

export default function PrivacyPage() {
  const dispatch = useDispatch();
  const { cms, error, isLoading } = useSelector((state) => state.cms);
  const pageTitle = 'Privacy Policy';

  useEffect(() => {
    dispatch(getCms('pp'));
  }, [dispatch]);

  return (
    <>
      <Seo
        title={pageTitle}
        description="Read how ASAP UAE collects, uses, protects and manages personal information submitted through its website, applications and learning services."
        path="/privacy"
      />

      {!cms && isLoading ? (
        <LoadSkeleton />
      ) : !cms && error ? (
        <Widget404 item={pageTitle} subitem={`No data found for ${pageTitle}`} />
      ) : !cms ? (
        <LoadSkeleton />
      ) : (
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            {
              name: 'Home',
              href: '/',
            },
            { name: `${pageTitle}` },
          ]}
        />

        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Box sx={{ p: { xs: 3, md: 5 } }}>
              <Typography variant="h6" sx={{ mb: 5 }}>
                {pageTitle}
              </Typography>

              <Markdown children={cms.content} />
            </Box>
          </Grid>
        </Grid>
      </Container>
      )}
    </>
  );
}
